export default __webpack_public_path__ + "static/media/ic_arrow-circle-right.ec4dd0b3.svg";